<template>
  <div>
    <el-table
        class="history-table"
        v-if="options"
        :data="tableData"
        style="width: 100%">
      <el-table-column

      >
        <template slot-scope="scope">
           {{ scope.row.title }}
          <span v-if="sign === '+' && scope.row.execution === 'operator'" class="history-table__star">*</span>
        </template>
      </el-table-column>
      <el-table-column
          align="right"
          width="100"
          prop="amount">
        <template slot-scope="scope">
          <div class="amount-value"> {{ sign }}{{ scope.row.amount }} H₵</div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  name: "RulesTable",
  data() {
    return {
      loading: false
    }
  },
  props: {
    options: {
      required: true
    },
    type: {
      required: true

    }
  },
  filters: {
  },
  computed: {
    tableData() {
      return this.options.filter(item => item.type === this.type)
    },
    sign() {
      return this.type === 'decrease' ? '-' : '+'
    }
  }

}
</script>
<style lang="scss" scoped>
.history-table {
  margin-top: 8px;

  /deep/ th .cell {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 13px;

    color: #111;
  }

  /deep/ .el-table__header-wrapper {
    display: none;
  }

  /deep/ tr .cell {

    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;

    color: #111;

  }

  /deep/ th.is-leaf, td {
    padding: 6px 0 !important;
    border-bottom: none;
  }




  /deep/ .el-table__row {
    td {
      padding: 9px 0 !important;
      border-bottom: 0 !important;
    }

    td:last-child {
      border-bottom-right-radius: 4px;
      border-top-right-radius: 4px;
    }

    td:first-child {
      border-bottom-left-radius: 4px;
      border-top-left-radius: 4px;
    }
  }

  &__star {
    color: #FF6464;
  }

}

.amount-value {
  font-size: 14px;
  line-height: 22px;
  color: #676767;

}


</style>
